module.exports = __webpack_public_path__ + "img/welfare-view-more.b2400229.png";